import { createActionGroup, props } from '@ngrx/store';
import { IPortfolioMarketData } from '@easy-lib/modules/portfolio';

export const PortfolioMarketDataAction = createActionGroup({
	source: 'PortfolioMarketData',
	events: {
		upsertMarketDataItem: props<{ portfolioMarketDataItem: IPortfolioMarketData }>(),
		upsertMarketData: props<{ portfolioMarketDataItems: IPortfolioMarketData[] }>()
	}
});
